// Placeholder components for dbaas components that may not be needed
import React from 'react'

// ClusterPageShell - simple wrapper
import { Stack, Title, Button, Group } from '@tidbcloud/uikit'
import { IconArrowLeft } from '@tidbcloud/uikit/icons'
import { useNavigate } from 'react-router-dom'

interface ClusterPageShellProps {
  title: string
  titleProps?: React.ComponentProps<typeof Title>
  headerProps?: {
    withBack?: boolean
    onBackClick?: () => void
  }
  children: React.ReactNode
}

export const ClusterPageShell: React.FC<ClusterPageShellProps> = ({
  title,
  titleProps,
  headerProps,
  children
}) => {
  const navigate = useNavigate()

  const handleBack = () => {
    if (headerProps?.onBackClick) {
      headerProps.onBackClick()
    } else {
      navigate(-1)
    }
  }

  return (
    <Stack>
      <Group>
        {headerProps?.withBack && (
          <Button
            leftSection={<IconArrowLeft />}
            variant='subtle'
            onClick={handleBack}
          >
            Back
          </Button>
        )}
        <Title order={2} {...titleProps}>
          {title}
        </Title>
      </Group>
      {children}
    </Stack>
  )
}
